module.exports = __webpack_public_path__ + "static/media/elite svg.01bd80fa.svg";